import type { RefObject } from 'react'
import { useEffect, useState } from 'react'

export function useHover<T extends HTMLElement>({
  element,
}: {
  element: RefObject<T | null>
}) {
  const [hovered, setHovered] = useState(false)

  const target = element?.current

  useEffect(() => {
    if (!(target && target.addEventListener)) return

    const onMouseOver = () => setHovered(true)
    const onMouseOut = () => setHovered(false)

    target.addEventListener('mouseover', onMouseOver)
    target.addEventListener('mouseout', onMouseOut)

    return () => {
      target.removeEventListener('mouseover', onMouseOver)
      target.removeEventListener('mouseout', onMouseOut)
    }
  }, [target])

  return hovered
}
